import React from 'react';
import clsx from 'clsx';
import Button from '../Button';

export type ButtonOptions = {
  icon?: React.ReactNode;
  label?: string;
  action: string;
  active?: boolean; // ← allow marking a button as active
};

type ButtonGroupProps = {
  buttons: ButtonOptions[];
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  buttonClassName?: string;
  dividerClassName?: string;
  labelClassName?: string;
  onClick: (action: string) => void;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  className,
  onClick,
  buttonClassName = 'p-4',
  orientation = 'horizontal',
  dividerClassName = 'bg-lightGray',
  labelClassName = '',
}) => {
  return (
    <div
      className={clsx(
        'inline-flex',
        orientation === 'vertical' ? 'flex-col' : 'flex-row',
        className
      )}
    >
      {buttons.map((button, index) => (
        <React.Fragment key={index}>
          <div className="relative flex-1">
            <Button
              {...button}
              size="empty"
              type="empty"
              onClick={() => onClick && onClick(button.action)}
              className={clsx(
                'text-small w-full',
                button.active
                  ? 'bg-primary text-main border border-main bg-select '
                  : 'bg-white hover:bg-select  border border-border text-secondary',
                buttonClassName
              )}
              roundedLeft={index === 0}
              roundedRight={index === buttons.length - 1}
              orientation={orientation}
              icon={button.icon || null}
              label={button.label || ''}
              labelClassName={labelClassName}
            />

            {index < buttons.length - 1 && (
              <div
                className={clsx(
                  orientation === 'horizontal'
                    ? 'w-[0.1rem] h-[70%] top-1/2 translate-y-[-50%] right-0'
                    : 'h-[0.1rem] w-[70%] left-1/2 translate-x-[-50%] bottom-0',
                  dividerClassName,
                  'absolute'
                )}
              />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
